import {
  START_LOADING,
  FINISH_LOADING,
  CURRENT_ENTER,
  HEADER_STATUS,
  ROLE_ID,
  SET_ENTRA_MENUS
} from "./mutation-type";

const mutations = {
  // 切换左侧导航的显示状态
  [START_LOADING](state) {
    state.loading = true;
  },
  [FINISH_LOADING](state) {
    state.loading = false;
  },
  [CURRENT_ENTER](state, val) {
    state.currentPage = val;
  },
  [HEADER_STATUS](state, val) {
    state.headerStatus = val;
  },
  [SET_ENTRA_MENUS](state, val) {
    state.entraMenus = val;
  }
};

export default mutations;
